import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Prisma",
  "description": "Turborepo에서 Prisma를 사용하는 방법을 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Prisma는 직관적인 데이터 모델, 자동화된 마이그레이션, 타입 안전성 및 자동 완성 덕분에 데이터베이스 작업 시 새로운 수준의 개발자 경험을 제공합니다."
  }, {
    "heading": "",
    "content": "공식 가이드는 다음을 포함하여 Prisma를 Turborepo에 통합하는 방법을 설명합니다:"
  }, {
    "heading": "",
    "content": "Prisma 클라이언트 초기화"
  }, {
    "heading": "",
    "content": "클라이언트를 Internal Package로 패키징"
  }, {
    "heading": "",
    "content": "마이그레이션 수행"
  }, {
    "heading": "",
    "content": "로컬에서 애플리케이션 작업"
  }, {
    "heading": "",
    "content": "배포"
  }, {
    "heading": "예제",
    "content": "커뮤니티 지원 Prisma 예제를 시작하려면 다음을 실행하세요:"
  }],
  "headings": [{
    "id": "예제",
    "content": "예제"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), "는 직관적인 데이터 모델, 자동화된 마이그레이션, 타입 안전성 및 자동 완성 덕분에 데이터베이스 작업 시 새로운 수준의 개발자 경험을 제공합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.prisma.io/docs/guides/using-prisma-orm-with-turborepo#1-create-your-monorepo-using-turborepo",
        children: "공식 가이드"
      }), "는 다음을 포함하여 Prisma를 Turborepo에 통합하는 방법을 설명합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Prisma 클라이언트 초기화"
      }), "\n", _jsxs(_components.li, {
        children: ["클라이언트를 ", _jsx(_components.a, {
          href: "/docs/core-concepts/internal-packages",
          children: "Internal Package"
        }), "로 패키징"]
      }), "\n", _jsx(_components.li, {
        children: "마이그레이션 수행"
      }), "\n", _jsx(_components.li, {
        children: "로컬에서 애플리케이션 작업"
      }), "\n", _jsx(_components.li, {
        children: "배포"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "예제",
      children: "예제"
    }), "\n", _jsx(_components.p, {
      children: "커뮤니티 지원 Prisma 예제를 시작하려면 다음을 실행하세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " with-prisma"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
